import { defineStore } from "pinia";
import { useGlobalsSetup } from "./globals";

export const useGlobalsStore = defineStore("globals", () => {
  const globals = useGlobalsSetup();

  return {
    ...globals
  };
});
